import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import { RiCloseLine } from "react-icons/ri";
import TeacherSidenavbar from "./teacherSidenavbar";
import SuperAdminSidenavbar from "./superAdminSidenavbar";
import LogoutMenu from "../Layout/logout-menu";
import AdminNotificationsBell from "../Notifications/AdminNotificationsBell";

/** Total height of fixed mobile bar including safe-area inset (sync with Layout padding). */
export const MOBILE_TOP_BAR_OFFSET = "calc(56px + env(safe-area-inset-top, 0px))";

export default function MobileSidebar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  const userData = useSelector((state) => state.user.userData);
  const location = useLocation();

  useEffect(() => {
    onClose();
  }, [location.pathname, onClose]);

  const isTeacher =
    userData?.role?.length > 0 && userData?.role[0]?.name === "Teacher";

  return (
    <>
      <Flex
        display={{ base: "flex", md: "none" }}
        position="fixed"
        top={0}
        left={0}
        right={0}
        zIndex={1300}
        minH={MOBILE_TOP_BAR_OFFSET}
        pt="env(safe-area-inset-top, 0px)"
        pb={2}
        px={3}
        align="center"
        justify="space-between"
        bg="rgba(243, 236, 230, 0.97)"
        borderBottom="1px solid"
        borderColor="rgba(214, 206, 192, 0.9)"
        backdropFilter="blur(8px)"
        boxShadow="0 2px 12px rgba(139, 24, 40, 0.06)"
      >
        <IconButton
          ref={btnRef}
          aria-label="Open navigation menu"
          icon={<AiOutlineMenu size={22} />}
          onClick={onOpen}
          size="md"
          borderRadius="full"
          bg="#7A1422"
          color="#F7F2EC"
          _hover={{ bg: "#8B1828" }}
          _active={{ bg: "#8B1828" }}
        />
        <Flex align="center" gap={2} flexShrink={0}>
          {userData?.role?.length > 0 ? (
            <AdminNotificationsBell
              iconColor="#7A1422"
              hoverBg="rgba(122, 20, 34, 0.08)"
              variant="ghost"
              size="md"
            />
          ) : null}
          <LogoutMenu compact />
        </Flex>
      </Flex>

      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
        closeOnOverlayClick
        closeOnEsc
        size="xs"
      >
        <DrawerOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <DrawerContent maxW="min(100vw, 300px)" bg="#8B1828" borderRightWidth="0">
          <DrawerHeader
            borderBottomWidth="1px"
            borderColor="rgba(255,255,255,0.12)"
            py={3}
            px={4}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={3}
            bg="#8B1828"
          >
            <Text
              fontSize="md"
              fontWeight="800"
              color="#F7F2EC"
              letterSpacing="0.04em"
            >
              Navigation
            </Text>
            <IconButton
              aria-label="Close menu"
              icon={<RiCloseLine size={24} />}
              onClick={onClose}
              size="md"
              borderRadius="full"
              variant="ghost"
              color="#F7F2EC"
              _hover={{ bg: "rgba(255,255,255,0.12)" }}
            />
          </DrawerHeader>

          <DrawerBody p={0} overflowY="auto" flex="1" maxH="calc(100vh - 60px)">
            {userData?.role?.length > 0 ? (
              isTeacher ? (
                <TeacherSidenavbar embedded />
              ) : (
                <SuperAdminSidenavbar embedded />
              )
            ) : null}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
